import { Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Users, ShoppingBag, Heart } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen py-12" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-6">
            <span className="text-primary-foreground font-bold text-3xl">H</span>
          </div>
          <h1 
            className="text-4xl font-bold mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            About HabeshaTown
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Connecting the Habesha community across Canada
          </p>
        </div>

        {/* Content */}
        <div className="prose prose-gray max-w-none">
          <div className="bg-card border border-border rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <Heart className="h-6 w-6 text-primary" />
              Our Mission
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              HabeshaTown is a marketplace built specifically for the Habesha (Ethiopian and Eritrean) 
              community living in Canada. Our mission is to create a trusted platform where community 
              members can buy, sell, and promote their services, products, and opportunities.
            </p>
          </div>

          <div className="bg-card border border-border rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <ShoppingBag className="h-6 w-6 text-primary" />
              What We Offer
            </h2>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0"></span>
                <span><strong>Buy & Sell:</strong> List items, vehicles, electronics, and more within our community.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0"></span>
                <span><strong>Services:</strong> Find and offer services like catering, braiding, tutoring, and repairs.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0"></span>
                <span><strong>Housing:</strong> Discover rooms, apartments, and rentals from trusted community members.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0"></span>
                <span><strong>Jobs:</strong> Find employment opportunities and post job listings.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0"></span>
                <span><strong>Events:</strong> Promote community events, celebrations, and gatherings.</span>
              </li>
            </ul>
          </div>

          <div className="bg-card border border-border rounded-2xl p-8 mb-8">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <Users className="h-6 w-6 text-primary" />
              Our Community
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We believe in the strength of community. HabeshaTown is more than just a marketplace—it's 
              a place where Habesha people in Canada can connect, support each other's businesses, and 
              build lasting relationships.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Whether you're in Toronto, Calgary, Edmonton, Vancouver, or anywhere else in Canada, 
              HabeshaTown brings our community together.
            </p>
          </div>

          <div className="bg-primary/5 border border-primary/20 rounded-2xl p-8">
            <h2 className="text-2xl font-semibold mb-4 flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <MapPin className="h-6 w-6 text-primary" />
              Canada Only
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              HabeshaTown is designed exclusively for the Habesha community in Canada. All listings 
              and services are intended for users located within Canada.
            </p>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12 p-8 bg-muted/50 rounded-2xl">
          <h3 className="text-xl font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Have Questions?
          </h3>
          <p className="text-muted-foreground mb-4">
            We're here to help. Reach out to our support team.
          </p>
          <Link 
            to="/support" 
            className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-medium"
          >
            Contact Support
            <ArrowLeft className="h-4 w-4 rotate-180" />
          </Link>
        </div>
      </div>
    </div>
  );
}
